import { format } from 'date-fns';
import styled from 'styled-components';

import { hasPublishAsLastAction } from './VideoVersionsAggregation';

import type { VideoAction } from '../../types.ts/story';

const LastVideoAction = ({ lastAction }: { lastAction: VideoAction }) => {
  const { type, editor, resolution, date } = lastAction;
  const formattedAction = {
    save: 'Saved',
    autosave: 'Autosaved',
    unsave: 'Unsaved',
    publish: 'Published',
    system_render_start: 'Modified',
    system_render_update: 'Modified',
    system_render_error: 'Modified',
    system_render_confirm: 'Published',
  }[type];
  const formattedDate = date ? format(new Date(date), 'MM/dd/yy') : null;
  const formattedTime = date ? format(new Date(date), 'h:mm a') : null;

  if (!type || !date) return null;

  return (
    <Container>
      {formattedAction} by {editor}
      {hasPublishAsLastAction(lastAction) && resolution
        ? ` in ${resolution}`
        : ''}{' '}
      on {formattedDate} {formattedTime}
    </Container>
  );
};

const Container = styled.div<{ marginTop?: number }>`
  color: var(--text-muted);
  font-size: var(--text-xs);
  line-height: var(--leading-text-xs);
  font-weight: var(--font-weight-normal);
  font-family: var(--font-primary);
`;

export default LastVideoAction;
